module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": true,
      "pxFromTop": 1,
      "ariaLabel": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal special-day-modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [(_vm.isLoadingExisting) ? _c('Loader') : [_c('div', {
    staticClass: "do-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "input_title",
    staticClass: "d-input width-100",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('vue2.special_days.name_placeholder')
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "do-input-group"
  }, [_c('div', {
    staticClass: "special-day-modal__label-row"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.classes')))]), _vm._v(" "), _c('button', {
    staticClass: "special-day-modal__link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleAllClasses
    }
  }, [_vm._v("\n              " + _vm._s(_vm.allClassesSelected ? _vm.$t('vue2.special_days.clear') : _vm.$t('vue2.special_days.select_all')) + "\n            ")])]), _vm._v(" "), _c('DSelectCals', {
    attrs: {
      "items": _vm.klassCalendars,
      "itemsSelected": _vm.selectedClasses,
      "placeholder": _vm.$t('vue2.special_days.select_classes')
    },
    on: {
      "update": _vm.onClassesUpdate
    }
  }), _vm._v(" "), (_vm.hasTriedSave && _vm.selectedClasses.length === 0) ? _c('p', {
    staticClass: "special-day-modal__hint special-day-modal__hint--warning"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.special_days.no_classes_selected')) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-input-group-flex"
  }, [_c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.start_date')))]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.startDateMoment,
      "width100": true
    },
    on: {
      "changed": _vm.onStartChanged
    }
  })], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.end_date')))]), _vm._v(" "), _c('DateSelector', {
    attrs: {
      "date": _vm.endDateMoment,
      "minDate": _vm.form.startDate,
      "width100": true
    },
    on: {
      "changed": _vm.onEndChanged
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "do-input-group do-input-group--toggler",
    class: {
      'do-input-group--toggler--active': _vm.form.reduct
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.form.reduct = !_vm.form.reduct
      }
    }
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.special_days.reduct')))]), _vm._v(" "), _c('AppToggle', {
    attrs: {
      "allowChanges": false,
      "propOn": _vm.form.reduct
    }
  })], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div'), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "do-bttn",
    attrs: {
      "disabled": _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.special_days.cancel')) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': !_vm.isValid || _vm.isSaving,
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.special_days.save')) + "\n        ")])])]), _vm._v(" "), (_vm.showRemovalWarning) ? _c('ModalConfirmation', {
    attrs: {
      "showClose": false,
      "isShowConfirmDeleteMessage": false,
      "appendToBody": true,
      "isSubmitButtonLoading": _vm.isSaving
    },
    on: {
      "confirm": _vm.confirmRemovalAndSave,
      "close": function($event) {
        _vm.showRemovalWarning = false
      }
    }
  }, [_c('template', {
    slot: "item"
  }, [_c('h3', [_vm._v("Fjern klasser med brikker?")]), _vm._v(" "), _c('p', {
    staticClass: "special-day-modal__warning__text"
  }, [_vm._v("\n          Du fjerner klasser, der har brikker for denne omlagte dag: " + _vm._s(_vm.affectedRemovedClassNames.join(', ')) + ". Brikkerne slettes ikke automatisk.\n        ")])]), _vm._v(" "), _c('template', {
    slot: "confirmText"
  }, [_vm._v("Gem alligevel")])], 2) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b18fc178!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDays/SpecialDayModal.vue
// module id = 2094
// module chunks = 1